var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form",
        { attrs: { "data-vv-scope": "assign-approval" } },
        [
          _c("list-group-users", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            ref: "resendName",
            staticClass: "w-100",
            attrs: {
              autocomplete: "",
              label: "Usuarios de la oficina",
              name: "resendSubject",
              "data-cy": "user-resend",
              "parent-value": _vm.officeSelected,
              danger: _vm.errors.has("assign-approval.resendSubject"),
              "danger-text": _vm.errors.first("assign-approval.resendSubject")
            },
            model: {
              value: _vm.resendSubject.id,
              callback: function($$v) {
                _vm.$set(_vm.resendSubject, "id", $$v)
              },
              expression: "resendSubject.id"
            }
          })
        ],
        1
      ),
      _c("b-overlay", { attrs: { show: _vm.loading } }, [
        _c(
          "div",
          { staticClass: "text-right mt-2" },
          [
            _c(
              "b-button",
              {
                staticClass: "mr-2",
                attrs: {
                  "data-cy": "assign-flows-button",
                  variant: "primary",
                  size: "sm"
                },
                on: { click: _vm.assignFlows }
              },
              [_vm._v(" Asignar expedientes ")]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }